import { render } from "./HeaderRadagast.vue?vue&type=template&id=4115d8c0"
import script from "./HeaderRadagast.vue?vue&type=script&lang=js"
export * from "./HeaderRadagast.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__